(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blok-desktop-toggle"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('blok-desktop-toggle')){
 class BlokDesktopToggle extends HTMLElement{
  connectedCallback(){
   if(this.dataset.connected)return;
   this.dataset.connected='true';
   const button=this.querySelector('button');
   const item=this.closest('.menu-list__list-item');
   const link=item?.querySelector('[ref="menuitem"]');
   const menu=this.closest('header-menu');
   if(!button||!item||!link||!menu)return;
   const sync=()=>button.setAttribute('aria-expanded',link.getAttribute('aria-expanded')||'false');
   this.observer=new MutationObserver(sync);
   this.observer.observe(link,{attributes:true,attributeFilter:['aria-expanded']});
   button.addEventListener('click',()=>menu.activate({target:item}));
   button.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();menu.deactivate({target:item,relatedTarget:null,type:'blur'});}});
   sync();
  }
  disconnectedCallback(){this.observer?.disconnect();delete this.dataset.connected;}
 }
 customElements.define('blok-desktop-toggle',BlokDesktopToggle);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blok-faq-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 const link=event.target.closest('.bf-topics a');
 if(!link)return;
 const target=document.getElementById(link.hash.slice(1));
 if(target instanceof HTMLDetailsElement)target.open=true;
});
const openFaqHash=()=>{const target=document.getElementById(location.hash.slice(1));if(target instanceof HTMLDetailsElement&&target.classList.contains('bf-group'))target.open=true;};
openFaqHash();
window.addEventListener('hashchange',openFaqHash);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blok-mobile-navigation"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('blok-mobile-navigation')){
class BlokMobileNavigation extends HTMLElement{
  connectedCallback(){
    if(this.dataset.connected)return;
    this.dataset.connected='true';
    this.addEventListener('click',event=>{
      const button=event.target.closest('.bn-toggle');
      if(!button||!this.contains(button))return;
      const expand=button.getAttribute('aria-expanded')!=='true';
      this.querySelectorAll('.bn-toggle').forEach(control=>this.setExpanded(control,control===button&&expand));
    });
    const outer=this.closest('header-drawer')?.querySelector('details');
    outer?.addEventListener('toggle',()=>{if(!outer.open)this.querySelectorAll('.bn-toggle').forEach(control=>this.setExpanded(control,false));});
  }
  setExpanded(control,expanded){
    control.setAttribute('aria-expanded',String(expanded));
    control.setAttribute('aria-label',expanded?control.dataset.collapseLabel:control.dataset.expandLabel);
    const panel=this.querySelector('[id="'+control.getAttribute('aria-controls')+'"]');
    if(panel)panel.hidden=!expanded;
  }
}
customElements.define('blok-mobile-navigation',BlokMobileNavigation);
}
  } catch(e) { console.error(e); }
})();

})();
